import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { NS } from '@/screens/Service/ducks/reducer';
import {
  getPublishedAnnouncement,
  updateCrumbs
} from '@/screens/Service/ducks/actions';

import { PublishedPage } from '../../components/PublishedPage';

export const PublishedAnnoucement = props => {
  const { updateCrumbs } = props;
  useEffect(() => {
    updateCrumbs([
      {
        label: 'Announcements',
        path: `/services/${props.service.get('handle')}/announcements`
      },
      { label: 'Announcement' }
    ]);
  }, []);
  return <PublishedPage language="md" {...props} />;
};

const mapStateToProps = state => ({
  service: state.getIn([NS, 'service']),
  publishedPage: state.getIn([NS, 'publishedAnnouncement']),
  pending: state.getIn([NS, 'pending', 'publishedAnnouncement']),
  canEdit: state.getIn([NS, 'team', 'is_member'], false)
});
const mapDispatchToProps = dispatch => ({
  getPublishedPage: pageId => dispatch(getPublishedAnnouncement(pageId)),
  updateCrumbs: crumbs => dispatch(updateCrumbs(crumbs))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PublishedAnnoucement);
